export default __webpack_public_path__ + "static/media/pdf-download-icon.e8f44ae8.png";